import { useCallback, useContext, useEffect, useRef, useState } from "react";
import "./Callback.css";
import { Box } from "@mui/system";
import { CircularProgress } from "@mui/material";
import { AppContext } from "../../store/AppProvider";
import { BULLETIN_TOKEN, REDIRECT_PATH, VIEW_BULLETIN_PATH } from "../../utils/constants";
import { handleCreateTabSession } from "../../hooks/useManageTabSession";
import ErrorHandler from "../errors/ErrorHandler";
export default function Callback() {
	const { setUserState } = useContext(AppContext);
	const [loginDone, setLoginDone] = useState(false);
	const [isError, setError] = useState(false);
	console.log("Callback reloading");
	useEffect(() => {
		if (!loginDone) {
			(async () => {
				try {
					await handleCreateTabSession(true,setUserState);
					setLoginDone(true);
				} catch (error) {
					console.log("Something went wrong in Callback", error);
					localStorage.clear()
					sessionStorage.clear();
					setError(true);
				}
			})();
		}
	}, [setUserState, loginDone]);

	const handleRedirect = useCallback(() => {
		const redirect = localStorage.getItem(REDIRECT_PATH) ?? "/";
		let path = redirect === VIEW_BULLETIN_PATH ? `${redirect}?token=${localStorage.getItem(BULLETIN_TOKEN)}` : redirect;
		localStorage.removeItem(REDIRECT_PATH);
		localStorage.removeItem(BULLETIN_TOKEN);
		return path;
	}, []);

	useEffect(() => {
		if (loginDone) {
			const path = handleRedirect();
			window.location.replace(path);
		}
	}, [loginDone]);

	return <FullPageLoading isError={isError} />;
}

export function FullPageLoading({ isError }) {
	return (
		<>
			{isError ? (
				<div style={{height:"100%",display:"flex"}}>
					<ErrorHandler title={"Unable to log you in"} desc={'Please try again later'}/>
				</div>
			) : (
				<Box className='progressBox'>
					<CircularProgress className='progressBox__Loader' />
				</Box>
			)}
		</>
	);
}
